// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iwNH4","title":"Info_title__iH4SJ","links":"Info_links__3lPeV","link":"Info_link__1nE6B","logo":"Info_logo__186UD"};